import { useContent } from "@/lib/useContent";
import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";
import About from "@/components/landing/About";
import Promise from "@/components/landing/Promise";
import Stats from "@/components/landing/Stats";
import { Reveal } from "@/components/landing/Reveal";

export default function AboutPage() {
  const content = useContent();

  if (!content) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#FAF9F5]" data-testid="about-page-loader">
        <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#8896AB]">loading</span>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#FAF9F5] text-[#0F1B2B]" data-testid="about-page">
      <Navbar brand={content.brand} />
      <section className="relative overflow-hidden pt-36 pb-16 lg:pt-44" data-testid="about-page-hero">
        <div className="pointer-events-none absolute inset-0 bg-[linear-gradient(rgba(15,27,43,0.045)_1px,transparent_1px),linear-gradient(90deg,rgba(15,27,43,0.045)_1px,transparent_1px)] bg-[size:72px_72px] [mask-image:radial-gradient(ellipse_at_top,black_30%,transparent_75%)]" />
        <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
          <Reveal>
            <div className="mb-4 flex items-center gap-3">
              <span className="font-mono text-xs text-[#B8860B]">{"\u0950"}</span>
              <span className="h-px w-10 bg-[#B8860B]/40" />
              <span className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-[#0E8A8A]">About Us</span>
            </div>
          </Reveal>
          <Reveal delay={0.08}>
            <h1 className="max-w-3xl font-syne text-4xl font-bold leading-[1.08] tracking-tight text-[#0F1B2B] sm:text-5xl">
              The story behind <span className="text-gold">{content.brand.name}</span>
            </h1>
          </Reveal>
        </div>
      </section>
      <About about={content.about} />
      <Stats stats={content.stats} />
      <Promise items={content.promise} />
      <Footer brand={content.brand} contact={content.contact} social={content.social} footer={content.footer} />
    </div>
  );
}
